import React from 'react';
import { cn } from './cn';

const BASE =
  'w-full rounded-ga-sm border bg-ga-bg-page/80 px-3 py-2.5 text-sm text-ga-text-primary outline-none transition placeholder:text-ga-text-subtle focus:ring-2';

export default function Input({ className, error, ...props }) {
  return (
    <input
      className={cn(
        BASE,
        error
          ? 'border-ga-danger focus:border-ga-danger focus:ring-ga-danger/30'
          : 'border-slate-400/40 focus:border-ga-accent focus:ring-ga-focus',
        className
      )}
      {...props}
    />
  );
}
